export default function Pump() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path
                d="M29.25 23.875L29.25 12.125C29.25 11.0204 28.3546 10.125 27.25 10.125L7.625 10.125C6.52043 10.125 5.625 11.0204 5.625 12.125L5.625 23.875C5.625 24.9796 6.52043 25.875 7.625 25.875L27.25 25.875C28.3546 25.875 29.25 24.9796 29.25 23.875Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M32.625 20.25L32.625 15.75L29.25 15.75L29.25 20.25L32.625 20.25Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.875 10.125L25.875 7.875L20.25 7.875L20.25 10.125L25.875 10.125Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.125 7.875L28.125 5.625L18 5.625L18 7.875L28.125 7.875Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.75 25.875L24.75 10.125L9 10.125L9 25.875L24.75 25.875Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11 14L22.25 14" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11 18L22.25 18" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11 22L22.25 22" stroke="#707070" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M6.75 30.375L27 30.375C27.6213 30.375 28.125 29.8713 28.125 29.25C28.125 28.6287 27.6213 28.125 27 28.125L6.75 28.125C6.12868 28.125 5.625 28.6287 5.625 29.25C5.625 29.8713 6.12868 30.375 6.75 30.375Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.75 28.125L24.75 25.875L9 25.875L9 28.125L24.75 28.125Z"
                stroke="#707070"
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
